import Model from "@/app/models/Concerns/Model";
import {AxiosResponse} from "axios";
import Client from "@/app/Http/Client";
import ProductionOrder from "./ProductionOrder";
import PaginatedResponse from "./Concerns/PaginatedResponse";

export default class Cluster extends Model {
    cluster_code!: string;
    description!: string;

    public static async current(): Promise<Cluster> {
        const constructor = this as Function;
        const response: AxiosResponse<{ data: Cluster }> = await Client.get([this.table, 'current'].join('/'));

        // @ts-ignore
        return new constructor(response.data.data);
    }

    public static async productionOrders(page: number = 1, params: { [key: string]: any } = {}): Promise<PaginatedResponse<ProductionOrder>> {
        const response: AxiosResponse<{ o: { [s: string]: number | string | null } }> = await Client.get([this.table, 'production-orders'].join('/'), {
            params: {
                page,
                ...params,
            }
        });

        // @ts-ignore
        return new PaginatedResponse<ProductionOrder>(response.data, ProductionOrder);
    }

    getTable(): string {
        return "clusters";
    }
}
